import type { IAuditoriaTelaAlteracao } from "@/api/space/dtos/authenticator.dto";
import BadgeAcao from "./BadgeAcao";

/**
 * Tela (acesso) com as suas permissões aninhadas — agrupamento visual Tela → Permissões (imagem2).
 */
export default function SecaoTelaPermissoes({ tela }: { readonly tela: IAuditoriaTelaAlteracao }) {
	return (
		<div className="overflow-hidden rounded-md border border-border/60 bg-muted/20">
			<div className="flex items-center gap-2 px-2.5 py-2">
				<BadgeAcao acao={tela.acao} />
				<span className="min-w-0 flex-1 truncate text-sm font-bold text-foreground">
					{tela.descricao || tela.tag}
				</span>
				<span className="shrink-0 text-[11px] text-muted-foreground">{tela.tag}</span>
			</div>

			{tela.permissoes.length > 0 ? (
				<div className="flex flex-col gap-1.5 border-t border-border/60 px-2.5 py-2">
					{tela.permissoes.map((permissao) => (
						<div key={permissao.tag} className="flex items-center gap-2 border-l-2 border-border/60 pl-2.5">
							<BadgeAcao acao={permissao.acao} />
							<span className="min-w-0 flex-1 truncate text-sm text-foreground">
								{permissao.descricao || permissao.tag}
							</span>
							<span className="shrink-0 text-sm text-muted-foreground">{permissao.tag}</span>
						</div>
					))}
				</div>
			) : null}
		</div>
	);
}
